import React, { Component } from "react";
import PlusSignSVG from "../../../Assets/svg/PlusSignSVG.svg";
import SendIconSVGDark from "../../../Assets/svg/SendIconSVGDark.svg";
import {
  SendMessageAction,
  resetHasRespondedToWhatsAppMessage,
  FetchIndividualWhatsAppMessagesAction,
} from "../../../Actions/Messaging";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";

class ChatInput extends Component {
  static propTypes = {
    SendMessageAction: PropTypes.func.isRequired,
    recipient: PropTypes.string.isRequired, // Phone number or ID of the recipient
    messageSent: PropTypes.bool.isRequired,
    FetchIndividualWhatsAppMessagesAction: PropTypes.func.isRequired,
    resetHasRespondedToWhatsAppMessage: PropTypes.func.isRequired,
    messageSent: PropTypes.bool.isRequired,
  };

  state = {
    message: "",
  };

  componentDidUpdate(prevProps) {
    const recipient = this.getPhoneNumber();

    // Check if the message was just sent
    if (!prevProps.messageSent && this.props.messageSent) {
      this.props.FetchIndividualWhatsAppMessagesAction(recipient);

      // Reset response state after 1 second
      setTimeout(() => {
        this.props.resetHasRespondedToWhatsAppMessage();
      }, 2000);
    }
  }

  getPhoneNumber = () => {
    const { pathname } = this.props.location;
    return pathname.split("/").pop();
  };

  handleInputChange = (e) => {
    this.setState({ message: e.target.value });
  };

  handleSendMessage = async () => {
    const { message } = this.state;
    const recipient = this.getPhoneNumber();

    if (!message.trim()) {
      alert("Please enter a message before sending.");
      return;
    }

    try {
      await this.props.SendMessageAction(recipient, message);
      this.setState({ message: "" }); // Clear the input field after sending
    } catch (err) {
      console.error("Failed to send message:", err);
    }
  };

  render() {
    return (
      <div className="w-full bg-white border-t border-gray-200 px-4 py-3 flex items-center gap-3">
        <button className="p-2 rounded-full hover:bg-gray-100 transition-colors shrink-0">
          <img src={PlusSignSVG} alt="Plus Sign" className="w-5 h-5" />
        </button>
        <input
          className="flex-1 bg-gray-50 border border-gray-200 rounded-full px-4 py-2 text-sm font-inter focus:outline-none focus:ring-1 focus:ring-primary-blue focus:border-primary-blue"
          type="text"
          value={this.state.message}
          onChange={this.handleInputChange}
          placeholder="Type your message here..."
        />
        <button
          onClick={this.handleSendMessage}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors shrink-0"
        >
          <img src={SendIconSVGDark} alt="Send" className="w-5 h-5" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messageSent: state.messaging.messageSent,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    SendMessageAction,
    FetchIndividualWhatsAppMessagesAction,
    resetHasRespondedToWhatsAppMessage,
  })(ChatInput)
);
